<svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="19" cy="19" r="19" fill="#009AFF"/>
<g clip-path="url(#clip0_0_768)">
<path d="M25.5029 17.8028L26.2931 18.5956C26.6276 18.9313 26.6276 19.4741 26.2931 19.8062L19.3771 26.7482C19.0425 27.0839 18.5015 27.0839 18.1705 26.7482L11.2509 19.8062C10.9164 19.4705 10.9164 18.9277 11.2509 18.5956L12.0411 17.8028C12.3793 17.4636 12.931 17.4707 13.262 17.8171L17.3482 22.1202V11.857C17.3482 11.3821 17.7291 11 18.2025 11H19.3415C19.8149 11 20.1958 11.3821 20.1958 11.857V22.1202L24.282 17.8171C24.613 17.4671 25.1647 17.46 25.5029 17.8028Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_0_768">
<rect width="16" height="16" fill="white" transform="translate(11 11)"/>
</clipPath>
</defs>
</svg>
